
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/image-and-text",
      function () {
        return require("private-next-pages/design-system/examples/image-and-text.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/image-and-text"])
      });
    }
  